import React, {useState} from 'react';
import SortingModal from "../../modals/SortingModal";

function SortComponent(props){

    const [isSortOptionChecked, setIsSortOptionChecked] = useState(false);
    const [isDropDownActiveStateChecked, setIsDropdownActiveStateChecked] = useState(false);
    const [isAscendingSelected, setIsAscendingSelected] = useState(false);
    const [shouldModalShown, setShouldModalShown] = useState(false);
    const [isColumnsDropdownActive, setIsColumnDropDownActive] = useState(false);
    const [targetSortColumn, setTargetSortColumn] = useState(null);

    function handleOnCheck(){
        setIsSortOptionChecked(!isSortOptionChecked);
        if(isSortOptionChecked === false){
            props.sortingHandler({
                option : 'desc',
                sortingColumn: props.answer ?  Object.keys(props.answer)[0] : null
            });
        }else{
            setIsDropdownActiveStateChecked(false);
            setIsColumnDropDownActive(false);
            props.sortingHandler({
                option : 'revert',
                sortingColumn: null
            });
        }

    }

    function onActiveStateClick(){

        let width = (window.innerWidth > 0) ? window.innerWidth : screen.width;

        if(!isDropDownActiveStateChecked && width <= 767){
            setShouldModalShown(true);
        }else{
            setIsDropdownActiveStateChecked(!isDropDownActiveStateChecked);
        }
    }

    function onActiveColumnDropdown(){

        let width = (window.innerWidth > 0) ? window.innerWidth : screen.width;

        if(!isDropDownActiveStateChecked && width <= 767){
            setShouldModalShown(true);
        }else{
            setIsColumnDropDownActive(!isColumnsDropdownActive);
        }
    }

    function onAscendingSelected(){
        if(isAscendingSelected === false){
            props.sortingHandler({
                option : 'asc',
                sortingColumn: (targetSortColumn == null && props.answer) ? Object.keys(props.answer)[0] : targetSortColumn
            });
        }else{
            props.sortingHandler({
                option : 'desc',
                sortingColumn: (targetSortColumn == null && props.answer) ? Object.keys(props.answer)[0] : targetSortColumn
            });
        }

        setIsAscendingSelected(!isAscendingSelected);
        setIsDropdownActiveStateChecked(false);
    }

    function closeModal(){
        setShouldModalShown(false);
    }

    function applySorting(sortOption){
        setShouldModalShown(false);
        if(sortOption.option === "desc"){
           setIsAscendingSelected(false);
        }
        if(sortOption.option === 'asc'){
            setIsAscendingSelected(true);
        }
        if(typeof sortOption.sortingColumn !== 'undefined'){
            setTargetSortColumn(sortOption.sortingColumn);
        }
        props.sortingHandler(sortOption);
    }

    function applyTargetSortColumn(columnName){
        setTargetSortColumn(columnName);
        setIsColumnDropDownActive(false);
        props.sortingHandler({
            option : isAscendingSelected ? 'asc' : 'desc',
            sortingColumn : columnName
        });
    }

    function createColumnNames(){
        let data = [];
        for (let propertyName of Object.keys(props.answer)){
            data.push
            (<span
                onClick={() => applyTargetSortColumn(propertyName)}
                key={props.answer[propertyName]}
                className="reports_content_sorting__by__dropdown__item">{propertyName}
            </span>);
        }
        return data;
    }


    return(
    <div className="reports_content_sorting">
        <div className="reports_content_sorting__order">
            <label className="reports_content_sorting__order__checkbox" htmlFor={"sort_1" + props.questionId}>
                <input className="sorting__checkbox__input" onChange={handleOnCheck} name={"sort_1" + props.questionId} type="checkbox" id={"sort_1" + props.questionId}/>
                <span className="sorting__checkbox__icon"></span>
                <span className="sorting__checkbox__text">Sort</span>
            </label>
            <div onClick={() => onActiveStateClick()} className={isSortOptionChecked ? "reports_content_sorting__order__selector reports_content_sorting__order__selector--show" : "reports_content_sorting__order__selector"}>{isAscendingSelected ? "Ascending" : "Descending"}</div>
            {
                isSortOptionChecked && <div className="reports_content_sorting__by__icon__asc-dsc" onClick={() => onActiveStateClick()} ></div>
            }
            <div className={isDropDownActiveStateChecked ? "reports_content_sorting__order__dropdown reports_content_sorting__order__dropdown--open" : "reports_content_sorting__order__dropdown"}>
                <span onClick={() => onAscendingSelected()}
                    className= {!isAscendingSelected ? "reports_content_sorting__order__dropdown__item reports_content_sorting__order__dropdown__item--selected" : "reports_content_sorting__order__dropdown__item"}>
                    Descending</span>
                <span onClick={() => onAscendingSelected()}
                    className={isAscendingSelected ? "reports_content_sorting__order__dropdown__item reports_content_sorting__order__dropdown__item--selected" : "reports_content_sorting__order__dropdown__item reports_content_sorting__order__dropdown__item"}>
                    Ascending</span>
            </div>
        </div>
        {typeof props.answer !== "undefined" &&
        <div className={isSortOptionChecked ? "reports_content_sorting__by reports_content_sorting__by--show" : "reports_content_sorting__by"}>
            <div className="reports_content_sorting__by__text">by</div>
            <div className="reports_content_sorting__by__selector" onClick={() => onActiveColumnDropdown()}>
                {targetSortColumn === null ? Object.keys(props.answer)[0] : targetSortColumn}
            </div>
            <div className="reports_content_sorting__by__icon" onClick={() => onActiveColumnDropdown()} ></div>
            <div className={isColumnsDropdownActive ? "reports_content_sorting__by__dropdown reports_content_sorting__by__dropdown--open" : "reports_content_sorting__by__dropdown"}>
                {createColumnNames()}
            </div>
        </div>
        }
        <SortingModal answer={props.answer} applySorting={applySorting} closeModal={closeModal} modalShown={shouldModalShown}/>
    </div>)
}

export default SortComponent;